import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

const notifications = [
  {
    "title": "Daily challenges",
    "description": "Your submission has been accepted",
  },
  {
    "title": "Daily challenges",
    "description": "Your submission not been accepted",
  },
  {

    "title": "Mailbox",
    "description": "You have 15 unread mails across 3 mailboxes",

  },
  {
    "title": "Cron jobs",
    "description": "Your Docker container is ready to publish",

  },

]


const NotificationCard = () => {
  return (
    <Card 
    className='min-w-[275px] h-[300px] m-16'
    // sx={{ minWidth: 275, height:"350px", margin: "10px" }}
    >
      <CardContent>
        <div>
          <Typography variant="h4" component="div" >
            {"Notifications"}
          </Typography>
            </div>
        {notifications.map((item) => (
          <Typography variant="body2" sx={{ margin: "10px" }}>
            <KeyboardDoubleArrowRightIcon/> {item.description}

          </Typography>
        ))}
        {/* <Typography variant="h6" component="div">
          {item.title}
        </Typography> */}

      </CardContent>

    </Card>
  );
}

export default NotificationCard

